module.exports = __webpack_public_path__ + "img/1.1338f4b8.jpg";